export default __webpack_public_path__ + "static/media/menugoodwood42finalfinal.d27f4351.pdf";